import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";


const CheckoutShell = ({ eyebrow = "Secure checkout", title, children }) => (
  <div className="min-h-screen">
    <Navbar />
    <main className="relative min-h-[75vh] px-6 pb-20 pt-36">
      <div className="absolute inset-0 grid-bg opacity-20" />
      <div className="relative mx-auto max-w-2xl rounded-2xl border border-slate-800 bg-slate-950/85 p-7 text-center shadow-2xl md:p-10">
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-xl border border-primary/30 bg-primary/10">
          <ShieldCheck className="h-7 w-7 text-primary" />
        </div>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-primary">{eyebrow}</p>
        <h1 className="text-3xl font-bold tracking-tight text-white md:text-4xl">{title}</h1>
        <div className="mt-6 text-sm leading-7 text-muted-foreground">{children}</div>
        <Link to="/products" className="mt-8 inline-block text-sm font-semibold text-primary hover:text-white">
          Back to products
        </Link>
      </div>
    </main>
    <Footer />
  </div>
);

export default CheckoutShell;
